import { h } from 'preact';
import { FC, lazy, useRef } from 'preact/compat';
import { Box, Divider, Grid, MenuItem } from '@mui/material';
const TextField = lazy(() => import('@mui/material/TextField'));
import { IBaseInfo, IEditType } from '../..';
import useGetFullHeight from '../../../../hooks/useGetFullHeight';

interface IProps {
  editType: IEditType;
  baseInfo: IBaseInfo;
  onChangeBaseInfo: (name: keyof IBaseInfo) => (...arg: unknown[]) => void;
}

const currencies = [
  { value: '宋体', label: '宋体' },
  { value: 'fangsong', label: '仿宋' },
  { value: 'cursive', label: '草书' },
  { value: 'serif', label: '衬线' },
  { value: 'kai', label: '楷体' },
];

const Edit: FC<IProps> = (props) => {
  const { editType, baseInfo, onChangeBaseInfo } = props;

  const editWrapRef = useRef(null);
  const editWrapHeight = useGetFullHeight(editWrapRef.current, {
    clearance: 30,
  });

  const formGridXs = editType === 'base' ? 6 : 6;
  const formGridMd = editType === 'base' ? 3 : 6;

  return (
    <Box
      component="form"
      sx={{
        '& .MuiTextField-root': { width: '100%' },
        maxHeight: { md: editWrapHeight },
      }}
      noValidate
      autoComplete="off"
      ref={editWrapRef}
      style={{
        overflow: 'scroll',
      }}
    >
      <Box>
        <Divider
          textAlign="left"
          style={{ fontWeight: 'bold', marginTop: 10, marginBottom: 10 }}
        >
          整体设置
        </Divider>

        <Grid container spacing={2}>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="宽度"
              size="small"
              type="number"
              variant="outlined"
              value={baseInfo.width}
              onChange={onChangeBaseInfo('width')}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="高度"
              size="small"
              type="number"
              max={2000}
              variant="outlined"
              value={baseInfo.height}
              onChange={onChangeBaseInfo('height')}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="左右留白大小"
              size="small"
              type="number"
              variant="outlined"
              value={baseInfo.padding}
              onChange={onChangeBaseInfo('padding')}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="顶部间距"
              size="small"
              type="number"
              variant="outlined"
              value={baseInfo.marginTop}
              onChange={onChangeBaseInfo('marginTop')}
            />
          </Grid>
          {/* <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="背景颜色"
              size="small"
              variant="outlined"
              value={baseInfo.backgroundColor}
              onChange={onChangeBaseInfo('backgroundColor')}
            />
          </Grid> */}
        </Grid>
      </Box>

      <Box>
        <Divider
          textAlign="left"
          style={{ fontWeight: 'bold', marginTop: 20, marginBottom: 10 }}
        >
          标题
        </Divider>
        <Grid container spacing={2}>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="标题字体"
              size="small"
              variant="outlined"
              select
              value={baseInfo.titleFontFamily}
              onChange={onChangeBaseInfo('titleFontFamily')}
            >
              {currencies.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="标题字体大小"
              size="small"
              type="number"
              variant="outlined"
              value={baseInfo.titleFontSize}
              onChange={onChangeBaseInfo('titleFontSize')}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="标题字体颜色"
              size="small"
              variant="outlined"
              value={baseInfo.titleFontColor}
              onChange={onChangeBaseInfo('titleFontColor')}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="标题下间距"
              size="small"
              type="number"
              variant="outlined"
              value={baseInfo.titleMarginBottom}
              onChange={onChangeBaseInfo('titleMarginBottom')}
            />
          </Grid>
          <br />
          <Grid item xs={12} md={12}>
            <TextField
              label="标题内容"
              size="small"
              variant="outlined"
              multiline
              rows={4}
              value={baseInfo.title}
              onChange={onChangeBaseInfo('title')}
            />
          </Grid>
        </Grid>
      </Box>

      <Box>
        <Divider
          textAlign="left"
          style={{ fontWeight: 'bold', marginTop: 20, marginBottom: 10 }}
        >
          内容
        </Divider>
        <Grid container spacing={2}>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="内容字体"
              size="small"
              variant="outlined"
              select
              value={baseInfo.contentFontFamily}
              onChange={onChangeBaseInfo('contentFontFamily')}
            >
              {currencies.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="内容字体大小"
              size="small"
              type="number"
              variant="outlined"
              value={baseInfo.contentFontSize}
              onChange={onChangeBaseInfo('contentFontSize')}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="内容字体颜色"
              size="small"
              variant="outlined"
              value={baseInfo.contentFontColor}
              onChange={onChangeBaseInfo('contentFontColor')}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="内容字体行高"
              size="small"
              type="number"
              variant="outlined"
              value={baseInfo.contentLineHeight}
              onChange={onChangeBaseInfo('contentLineHeight')}
            />
          </Grid>
          <br />
          <Grid item xs={12} md={12}>
            <TextField
              label="内容"
              size="small"
              variant="outlined"
              multiline
              rows={4}
              value={baseInfo.content}
              onChange={onChangeBaseInfo('content')}
            />
          </Grid>
        </Grid>
      </Box>

      <Box>
        <Divider
          textAlign="left"
          style={{ fontWeight: 'bold', marginTop: 20, marginBottom: 10 }}
        >
          右下文案
        </Divider>
        <Grid container spacing={2}>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="右下文案字体"
              size="small"
              variant="outlined"
              select
              value={baseInfo.rbContentFontFamily}
              onChange={onChangeBaseInfo('rbContentFontFamily')}
            >
              {currencies.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="右下文案字体大小"
              size="small"
              type="number"
              variant="outlined"
              value={baseInfo.rbContentFontSize}
              onChange={onChangeBaseInfo('rbContentFontSize')}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="右下文案字体颜色"
              size="small"
              variant="outlined"
              value={baseInfo.rbContentFontColor}
              onChange={onChangeBaseInfo('rbContentFontColor')}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="右下文案字体行高"
              size="small"
              type="number"
              variant="outlined"
              value={baseInfo.rbContentLineHeight}
              onChange={onChangeBaseInfo('rbContentLineHeight')}
            />
          </Grid>
          <br />
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="右下文案右偏移量"
              size="small"
              type="number"
              variant="outlined"
              value={baseInfo.rbRight}
              onChange={onChangeBaseInfo('rbRight')}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="右下文案下偏移量"
              size="small"
              type="number"
              variant="outlined"
              value={baseInfo.rbBottom}
              onChange={onChangeBaseInfo('rbBottom')}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="右下文案内容1"
              size="small"
              variant="outlined"
              multiline
              rows={4}
              value={baseInfo.rbContent1}
              onChange={onChangeBaseInfo('rbContent1')}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="右下文案内容2"
              size="small"
              variant="outlined"
              multiline
              rows={4}
              value={baseInfo.rbContent2}
              onChange={onChangeBaseInfo('rbContent2')}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Edit;
